<template>
  <modal :name="modal" :adaptive="true"  :reset="true" width="300" :scrollable="false"
    :height="'auto'">
    <card>
      <p>{{client.full_name}}</p>
      <p>{{table.date | dateFormat}}</p>

      <hr/>
    <ul class="attendances">
        <li @click="setAttendance(key)" v-for="(attendance, key) in attendances" :key="key">
            <span :style="{backgroundColor:attendance.color}"></span> <span>{{attendance.title}}</span>
        </li>
    </ul>
  </card>
  </modal>
    
</template>

<script>
// import { dateFormat } from '../../plugins/filtersTemplate';

export default {
    created() {

    },
    data() {
        return {
            attendances: [{
                    title: 'Присутствует',
                    color: 'green',
                },
                {
                    title: 'Опоздал',
                    color: 'red',
                },
                {
                    title: 'По болезни',
                    color: 'blue',
                },
                {
                    title: 'Неув.',
                    color: 'yellow',
                },
            ]
        };
    },
    props: ["value", "client", "table", "modal"],

    methods: {
        setAttendance(key) {
            this.$loading(true);
            this.$http.post(`business/timetables/${this.table.id}/clients`, { client: { ...this.client, status: key } })
                .then(() => {
                    this.$emit('input', key);
                    this.$modal.hide(this.modal);
                })
                .catch(() => {

                })
                .finally(() => {
                    this.$loading(false);
                })
        }
    }
};
</script>

<style lang="scss">
ul.attendances {
    background: #fff;

    display: block;

    z-index: 99;
    left: 0;
    top: 0;
    &>li {
        cursor: pointer;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        &>span {
            display: block;
            &:first-child {
                margin-right: 4px;
                border: 1px solid #ebebeb;
                border-radius: 100%;
                width: 20px;
                height: 20px;
                min-height: 20px;
                min-width: 20px;
                max-height: 20px;
                max-width: 20px;
            }
        }
    }
}
</style>

